export default __webpack_public_path__ + "static/media/EventstopBg.f7bf86fb.jpeg";